import React from "react";

import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Collapse,
  Container,
  Row,
  Col,
} from "reactstrap";


function AccordionPrivacy() {
  const [openedCollapse, setOpenedCollapse] = React.useState("collapse-1");
  return (
    <div className="accordion-1">
      <Container>
        <Row>
          <Col className="mx-auto text-center" md="6">
            <h2 className="title font-weight-bold mb-3 mt-5">Privacy Policy</h2>
          </Col>
        </Row>
        <Row>
          <Col className="ml-auto mb-5 bg-default" md="12">
            <div className="accordion" id="privacy">
              <Card className="bg-default">
                <CardHeader className="bg-default" id="Into">
                  <h4 className="text-white font-weight-normal">Last modified: March 27, 2023</h4>
                  <h5 className="mb-0">
                    <Button
                      aria-expanded={openedCollapse === "collapse-1"}
                      onClick={() =>
                        setOpenedCollapse(
                          openedCollapse === "collapse-1" ? "" : "collapse-1"
                        )
                      }
                      className="w-100 text-info text-left"
                      color="link"
                      type="button"
                    >
                      Introduction{" "}
                      <i className="ni ni-bold-down float-right pt-1"></i>
                    </Button>
                  </h5>
                </CardHeader>
                <Collapse isOpen={openedCollapse === "collapse-1"}>
                  <CardBody className="text-white font-weight-normal">
                    <p>
                      This Privacy Policy explains our policies and procedures for collecting, using, and disclosing 
                      your information while using the Service, as well as your privacy rights and how the law protects 
                      you. By using the Service, you agree to the collection and use of your personal data in accordance 
                      with this Privacy Policy.
                    </p>
                  </CardBody>
                </Collapse>
              </Card>
              <Card className="bg-default">
                <CardHeader className="bg-default" id="collection">
                  <h5 className="mb-0">
                    <Button
                      aria-expanded={openedCollapse === "collapse-2"}
                      onClick={() =>
                        setOpenedCollapse(
                          openedCollapse === "collapse-2" ? "" : "collapse-2"
                        )
                      }
                      className="w-100 text-info text-left collapsed"
                      color="link"
                      type="button"
                    >
                      Collection and Processing of Personal Data{" "}
                      <i className="ni ni-bold-down float-right pt-1"></i>
                    </Button>
                  </h5>
                </CardHeader>
                <Collapse isOpen={openedCollapse === "collapse-2"}>
                  <CardBody className="text-white font-weight-normal">
                    <p>
                      We respect your right to privacy and are committed to processing your personal data in a secure and 
                      private manner. We collect and process only the personal data that is necessary to provide and improve 
                      our services, and we do not sell personal data to third parties.
                    </p>
                    <p>
                      We may collect personal data such as your name, email address, and payment information when you use our 
                      services. We may also collect usage data, such as your IP address and browser type, to help us improve 
                      our services and for security purposes.
                    </p>
                    <p>
                      We process your personal data in a legitimate and intended manner. We establish defined goals for Personal 
                      Data Processing and only use Personal Data for these reasons. We never collect or process information that 
                      we don't require, and all transfers of personal information must have a legal basis. We also make every 
                      effort to ensure that the personal data we process is accurate and limited to only that which is required. 
                      We only keep personal data for a maximum of twelve months.
                    </p>
                  </CardBody>
                </Collapse>
              </Card>
              <Card className="bg-default">
                <CardHeader className="bg-default" id="personal">
                  <h5 className="mb-0">
                    <Button
                      aria-expanded={openedCollapse === "collapse-3"}
                      onClick={() =>
                        setOpenedCollapse(
                          openedCollapse === "collapse-3" ? "" : "collapse-3"
                        )
                      }
                      className="w-100 text-info text-left collapsed"
                      color="link"
                      type="button"
                    >
                      Use of Personal Data{" "}
                      <i className="ni ni-bold-down float-right pt-1"></i>
                    </Button>
                  </h5>
                </CardHeader>
                <Collapse isOpen={openedCollapse === "collapse-3"}>
                  <CardBody className="text-white font-weight-normal">
                    <p>
                      We use your personal data to offer and improve our services. We may also use your personal data for the 
                      following purposes:
                    </p>
                    <p>
                      Cryptegridy.com makes no representation, warranty, or guarantee that the content available through the 
                      Service is free of viruses or other code or computer programming routines with contaminating or 
                      destructive properties or intended to damage, surreptitiously intercept, or expropriate any system, 
                      data, or personal information.
                    </p>
                    <ul>
                      <li>
                        To prevent and detect fraud or money laundering.
                      </li>
                      <li>
                        To send out newsletters, marketing, developing, and promoting our Services, organising campaigns, 
                        including customised and targeted campaigns, and analysing the efficacy of the marketing activities 
                        we have conducted.
                      </li>
                    </ul>
                  </CardBody>
                </Collapse>
              </Card>
              <Card className="bg-default">
                <CardHeader className="bg-default" id="rights">
                  <h5 className="mb-0">
                    <Button
                      aria-expanded={openedCollapse === "collapse-4"}
                      onClick={() =>
                        setOpenedCollapse(
                          openedCollapse === "collapse-4" ? "" : "collapse-4"
                        )
                      }
                      className="w-100 text-info text-left"
                      color="link"
                      type="button"
                    >
                      Exercise of Privacy Rights{" "}
                      <i className="ni ni-bold-down float-right pt-1"></i>
                    </Button>
                  </h5>
                </CardHeader>
                <Collapse isOpen={openedCollapse === "collapse-4"}>
                  <CardBody className="text-white font-weight-normal">
                    <p>
                      You have the right to access, rectify, and erase your personal data, as well as the right to restrict or 
                      object to the processing of your personal data. To exercise these rights, you may contact our data protection 
                      officer at admin@cryptegridy.com. We will respond to all requests in a timely manner and in accordance with 
                      applicable data protection laws.
                    </p>
                  </CardBody>
                </Collapse>
              </Card>
              <Card className="bg-default">
                <CardHeader className="bg-default" id="data">
                  <h5 className="mb-0">
                    <Button
                      aria-expanded={openedCollapse === "collapse-5"}
                      onClick={() =>
                        setOpenedCollapse(
                          openedCollapse === "collapse-5" ? "" : "collapse-5"
                        )
                      }
                      className="w-100 text-info text-left"
                      color="link"
                      type="button"
                    >
                      Data Security{" "}
                      <i className="ni ni-bold-down float-right pt-1"></i>
                    </Button>
                  </h5>
                </CardHeader>
                <Collapse isOpen={openedCollapse === "collapse-5"}>
                  <CardBody className="text-white font-weight-normal">
                    <p>
                      The Site and the Service may contain links to websites of third parties &#40;&#8220;Third Party Sites&#8221;&#41;. 
                      You acknowledge that we have no control over such Third Party Sites, and you further acknowledge and agree that 
                      we are not responsible for the availability of Third Party Sites, and do not endorse and are not responsible or 
                      liable for any services, content, advertisements, products, or any materials on or available Third Party Sites.
                    </p>
                  </CardBody>
                </Collapse>
              </Card>
              <Card className="bg-default">
                <CardHeader className="bg-default" id="cookies">
                  <h5 className="mb-0">
                    <Button
                      aria-expanded={openedCollapse === "collapse-6"}
                      onClick={() =>
                        setOpenedCollapse(
                          openedCollapse === "collapse-6" ? "" : "collapse-6"
                        )
                      }
                      className="w-100 text-info text-left"
                      color="link"
                      type="button"
                    >
                      Cookies{" "}
                      <i className="ni ni-bold-down float-right pt-1"></i>
                    </Button>
                  </h5>
                </CardHeader>
                <Collapse isOpen={openedCollapse === "collapse-6"}>
                  <CardBody className="text-white font-weight-normal">
                    <p>
                      We use cookies to collect information about your use of our Site. Cookies are files with small amount of data, 
                      which may include an anonymous unique identifier. Cookies are sent to your browser from a web site and stored on 
                      your computer&#39;s hard drive. We use Google Analytics cookies and Cloudflare&#39;s Self-Serve Subscription Agreement 
                      for analytics. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. 
                      However, if you do not accept cookies, you may not be able to use some portions of our Site.
                    </p>
                  </CardBody>
                </Collapse>
              </Card>
              <Card className="bg-default">
                <CardHeader className="bg-default" id="changes">
                  <h5 className="mb-0">
                    <Button
                      aria-expanded={openedCollapse === "collapse-7"}
                      onClick={() =>
                        setOpenedCollapse(
                          openedCollapse === "collapse-7" ? "" : "collapse-7"
                        )
                      }
                      className="w-100 text-info text-left"
                      color="link"
                      type="button"
                    >
                      Changes to the Privacy Policy{" "}
                      <i className="ni ni-bold-down float-right pt-1"></i>
                    </Button>
                  </h5>
                </CardHeader>
                <Collapse isOpen={openedCollapse === "collapse-7"}>
                  <CardBody className="text-white font-weight-normal">
                    <p>
                      Please note that this Privacy Policy may be updated from time to time. We reserve the right to modify this 
                      policy at any time, without prior notice, so please check back frequently for any changes. We may notify 
                      you of significant changes to the Privacy Policy by posting a notice on our website or by sending you an 
                      email or other notification.
                    </p>
                  </CardBody>
                </Collapse>
              </Card>
              <Card className="bg-default">
                <CardHeader className="bg-default" id="contact">
                  <h5 className="mb-0">
                    <Button
                      aria-expanded={openedCollapse === "collapse-8"}
                      onClick={() =>
                        setOpenedCollapse(
                          openedCollapse === "collapse-8" ? "" : "collapse-8"
                        )
                      }
                      className="w-100 text-info text-left"
                      color="link"
                      type="button"
                    >
                      Contact Us{" "}
                      <i className="ni ni-bold-down float-right pt-1"></i>
                    </Button>
                  </h5>
                </CardHeader>
                <Collapse isOpen={openedCollapse === "collapse-8"}>
                  <CardBody className="text-white font-weight-normal">
                    <p>
                      If you have any questions or concerns about our Privacy Policy or our data practices, please contact us 
                      at<a className="text-info" href="mailto:admin@cryptegridy.com" target="_blank" rel="noreferrer">{" "} 
                      admin@cryptegridy.com</a>. We will respond to your inquiry as soon as possible.
                    </p>
                  </CardBody>
                </Collapse>
              </Card>
              <Card className="bg-default">
                <CardHeader className="bg-default" id="cookieshow">
                  <h5 className="mb-0">
                    <Button
                      aria-expanded={openedCollapse === "collapse-9"}
                      onClick={() =>
                        setOpenedCollapse(
                          openedCollapse === "collapse-9" ? "" : "collapse-9"
                        )
                      }
                      className="w-100 text-info text-left"
                      color="link"
                      type="button"
                    >
                      How We Use Cookies{" "}
                      <i className="ni ni-bold-down float-right pt-1"></i>
                    </Button>
                  </h5>
                </CardHeader>
                <Collapse isOpen={openedCollapse === "collapse-9"}>
                  <CardBody className="text-white font-weight-normal">
                    <p>
                      We use cookies and similar tracking technologies to collect and store information about your usage of 
                      our Service. Cookies are small data files that are placed on your computer or mobile device when you 
                      visit a website or use an app. They allow us to recognize your browser or device and remember your 
                      preferences and actions.
                    </p>
                    <p>
                      We use cookies for the following purposes:
                    </p>
                    <ul>
                      <li>
                        To provide and improve our Service: We use cookies to ensure that our Service functions properly, to 
                        remember your preferences and settings, and to improve our Service's performance and usability.
                      </li>
                      <li>
                        To analyze and measure usage: We use cookies to understand how users interact with our Service, to 
                        track and analyze usage trends, and to measure the effectiveness of our marketing campaigns.
                      </li>
                      <li>
                        To personalize your experience: We use cookies to personalize your experience on our Service, such as 
                        by showing you targeted advertisements or recommendations based on your interests and preferences.
                      </li>
                      <li>
                        To protect our Service: We use cookies to prevent fraudulent activity and to secure our Service against 
                        unauthorized access and attacks.
                      </li>
                    </ul>
                    <p>
                      By using our Service, you consent to our use of cookies and similar technologies as described in this 
                      Privacy Policy. You can control the use of cookies at the individual browser level, but if you choose to 
                      disable cookies, it may limit your use of certain features or functions of our Service.
                    </p>
                  </CardBody>
                </Collapse>
              </Card>
              <Card className="bg-default">
                <CardHeader className="bg-default" id="sites">
                  <h5 className="mb-0">
                    <Button
                      aria-expanded={openedCollapse === "collapse-10"}
                      onClick={() =>
                        setOpenedCollapse(
                          openedCollapse === "collapse-10" ? "" : "collapse-10"
                        )
                      }
                      className="w-100 text-info text-left"
                      color="link"
                      type="button"
                    >
                      Third-Party Sites{" "}
                      <i className="ni ni-bold-down float-right pt-1"></i>
                    </Button>
                  </h5>
                </CardHeader>
                <Collapse isOpen={openedCollapse === "collapse-10"}>
                  <CardBody className="text-white font-weight-normal">
                    <p>
                      Our Service may contain links to third-party websites or services that are not owned or controlled by us. We 
                      are not responsible for the privacy practices or the content of such third-party sites. We encourage you to 
                      read the privacy policies of these third-party sites before providing any personal information.
                    </p>
                  </CardBody>
                </Collapse>
              </Card>
              <Card className="bg-default">
                <CardHeader className="bg-default" id="security">
                  <h5 className="mb-0">
                    <Button
                      aria-expanded={openedCollapse === "collapse-11"}
                      onClick={() =>
                        setOpenedCollapse(
                          openedCollapse === "collapse-11" ? "" : "collapse-11"
                        )
                      }
                      className="w-100 text-info text-left"
                      color="link"
                      type="button"
                    >
                      Security{" "}
                      <i className="ni ni-bold-down float-right pt-1"></i>
                    </Button>
                  </h5>
                </CardHeader>
                <Collapse isOpen={openedCollapse === "collapse-11"}>
                  <CardBody className="text-white font-weight-normal">
                    <p>
                      We take the security of your personal information seriously and employ reasonable measures to protect it from 
                      unauthorized access, disclosure, alteration, or destruction. However, no method of transmission over the 
                      internet or method of electronic storage is completely secure, and we cannot guarantee absolute security.
                    </p>
                  </CardBody>
                </Collapse>
              </Card>
              <Card className="bg-default">
                <CardHeader className="bg-default" id="children">
                  <h5 className="mb-0">
                    <Button
                      aria-expanded={openedCollapse === "collapse-12"}
                      onClick={() =>
                        setOpenedCollapse(
                          openedCollapse === "collapse-12" ? "" : "collapse-12"
                        )
                      }
                      className="w-100 text-info text-left"
                      color="link"
                      type="button"
                    >
                      Children's Privacy{" "}
                      <i className="ni ni-bold-down float-right pt-1"></i>
                    </Button>
                  </h5>
                </CardHeader>
                <Collapse isOpen={openedCollapse === "collapse-12"}>
                  <CardBody className="text-white font-weight-normal">
                    <p>
                      Our Service is not intended for use by children under the age of 18, and we do not knowingly collect personal 
                      information from children under 18. If you are a parent or guardian and believe that your child has provided 
                      us with personal information, please contact us immediately. If we become aware that we have collected personal 
                      information from a child under 18, we will take steps to delete that information as soon as possible.
                    </p>
                  </CardBody>
                </Collapse>
              </Card>
              <Card className="bg-default">
                <CardHeader className="bg-default" id="international">
                  <h5 className="mb-0">
                    <Button
                      aria-expanded={openedCollapse === "collapse-13"}
                      onClick={() =>
                        setOpenedCollapse(
                          openedCollapse === "collapse-13" ? "" : "collapse-13"
                        )
                      }
                      className="w-100 text-info text-left"
                      color="link"
                      type="button"
                    >
                      International Data Transfers{" "}
                      <i className="ni ni-bold-down float-right pt-1"></i>
                    </Button>
                  </h5>
                </CardHeader>
                <Collapse isOpen={openedCollapse === "collapse-13"}>
                  <CardBody className="text-white font-weight-normal">
                    <p>
                      Your personal information may be transferred to and processed in countries other than the one in which you reside, 
                      where data protection and privacy regulations may not offer the same level of protection as in your home country. 
                      By using our Service, you consent to such transfers and processing.
                    </p>
                  </CardBody>
                </Collapse>
              </Card>
              <Card className="bg-default">
                <CardHeader className="bg-default" id="you">
                  <h5 className="mb-0">
                    <Button
                      aria-expanded={openedCollapse === "collapse-14"}
                      onClick={() =>
                        setOpenedCollapse(
                          openedCollapse === "collapse-14" ? "" : "collapse-14"
                        )
                      }
                      className="w-100 text-info text-left"
                      color="link"
                      type="button"
                    >
                      Your Rights{" "}
                      <i className="ni ni-bold-down float-right pt-1"></i>
                    </Button>
                  </h5>
                </CardHeader>
                <Collapse isOpen={openedCollapse === "collapse-14"}>
                  <CardBody className="text-white font-weight-normal">
                    <p>
                      Under data protection laws, you have certain rights regarding your personal information, including:
                    </p>
                    <ul>
                      <li>
                        Right to Access: You have the right to request access to the personal information we hold about you.
                      </li>
                      <li>
                        Right to Rectification: You have the right to request that we correct any inaccurate or incomplete 
                        personal information we hold about you.
                      </li>
                      <li>
                        Right to Erasure: You have the right to request that we delete your personal information under certain 
                        circumstances, such as if the information is no longer necessary for the purposes for which it was 
                        collected.
                      </li>
                      <li>
                        Right to Restrict Processing: You have the right to request that we limit the processing of your personal 
                        information under certain circumstances, such as if you contest the accuracy of the information we hold 
                        about you.
                      </li>
                      <li>
                        Right to Object to Processing: You have the right to object to the processing of your personal information 
                        under certain circumstances, such as if you believe the processing is unlawful or you have a legitimate 
                        interest to do so.
                      </li>
                      <li>
                        Right to Data Portability: You have the right to request that we provide you with a copy of your personal 
                        information in a structured, commonly used, and machine-readable format, or to transfer your personal 
                        information to another controller, under certain circumstances.
                      </li>
                      <li>
                        Right to Withdraw Consent: If we rely on your consent to process your personal information, you have the 
                        right to withdraw your consent at any time.
                      </li>
                    </ul>
                    <p>
                      If you wish to exercise any of these rights, please contact us using the contact details provided in this 
                      Privacy Policy. We will respond to your request as soon as possible and no later than one month after 
                      receiving it.
                    </p>
                    <p>
                      Please note that we may need to verify your identity before we can comply with your request.
                    </p>
                  </CardBody>
                </Collapse>
              </Card>
              <Card className="bg-default">
                <CardHeader className="bg-default" id="mail">
                  <h5 className="mb-0">
                    <Button
                      aria-expanded={openedCollapse === "collapse-15"}
                      onClick={() =>
                        setOpenedCollapse(
                          openedCollapse === "collapse-15" ? "" : "collapse-15"
                        )
                      }
                      className="w-100 text-info text-left"
                      color="link"
                      type="button"
                    >
                      Contact Us By Mail{" "}
                      <i className="ni ni-bold-down float-right pt-1"></i>
                    </Button>
                  </h5>
                </CardHeader>
                <Collapse isOpen={openedCollapse === "collapse-15"}>
                  <CardBody className="text-white font-weight-normal">
                    <p>
                      If you have any questions or concerns about this Privacy Policy, or if you would like to exercise 
                      any of your rights under data protection laws, please contact us at:
                    </p>
                    <p>
                      Email: <a className="text-info" href="mailto:admin@cryptegridy.com" target="_blank" rel="noreferrer">{" "} 
                      admin@cryptegridy.com</a>
                      <br></br>
                      Address: CrypTegridy LTD
                      <br></br>
                      Kemp House
                      <br></br>
                      128 City Road
                      <br></br>
                      London
                      <br></br>
                      EC1V 2NX
                    </p>
                  </CardBody>
                </Collapse>
              </Card>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default AccordionPrivacy;
